import styles from "../static/loader/styles.scss";
import LoaderHtml from "../static/loader/index.html";
import { LoaderProperties } from "../models/loader.models";
import { Helper } from "../helpers/helper";

export class LoaderUtility {
    private static readonly UNIQUE_ID: string = "VAIMISUtility_Loader";

    public static addLoader(loaderProperties: LoaderProperties = {}, parentSelector: any = document.body): string {
        // lazily include style tag when loader added
        styles.use();

        let properties: LoaderProperties = Object.assign(new LoaderProperties(), loaderProperties);
        let jParent = jQuery(parentSelector);

        let position = jParent.css("position");
        if (position == "static") {
            jParent.css("position", "relative");
        }

        let loaderId = this.UNIQUE_ID + "_" + Date.now();
        let jLoader = jQuery(LoaderHtml);
        jLoader.attr("id", loaderId);

        // applying properties
        let jLoaderText = jLoader.find(".va-imis-utility-loader-text");
        let jLoaderIcon = jLoader.find(".va-imis-utility-loader-icon");

        jLoaderText.text(properties.loaderText).css("font-size", properties.fontSize);
        jLoaderIcon.css({
            width: properties.width,
            height: properties.height
        });

        if (properties.isOpaque) {
            jLoader.css("background-color", "white");
            jLoaderText.css("color", "black");
        }

        if (properties.isFull) {
            jLoader.css({
                height: "100vh",
                position: "fixed"
            });
        } else if (!Helper.isStringNullOrEmpty(properties.containerHeight)) {
            jLoader.css("height", properties.containerHeight);

            // the following configuration depends on the above one to work properly
            if (properties.isPositionStatic) {
                jLoader.css("position", "static");
            }
        }

        jParent.append(jLoader);
        return loaderId;
    }

    public static removeLoader(loaderId: string) {
        let jLoader = jQuery("#" + loaderId);
        jLoader.remove();
    }
}